import actionTypes from 'src/modules/redux/actionTypes'

export const setAdForPromo = ad => ({
  type: actionTypes.SET_AD_FOR_PROMO,
  payload: ad
})
